"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryCommonWithSuspense = exports.EntryCommon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("@mui/material/styles");
var recoil_1 = require("recoil");
var react_1 = require("react");
var provider_1 = require("../Toast/provider");
var MswProvider_1 = require("../MswProvider");
var theme_1 = require("./theme");
var EntryCommon = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(MswProvider_1.MswProvider, { children: (0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, { theme: theme_1.chatBoostTheme, children: (0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { children: (0, jsx_runtime_1.jsx)(provider_1.ToastProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: children }) }) }) }) }));
};
exports.EntryCommon = EntryCommon;
// suspenseを入れずにrecoil(loadableではない)を利用しているケースで利用している。
var EntryCommonWithSuspense = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, { theme: theme_1.chatBoostTheme, children: (0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { children: (0, jsx_runtime_1.jsx)(provider_1.ToastProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: children }) }) }) }) }));
};
exports.EntryCommonWithSuspense = EntryCommonWithSuspense;
